import React, { useState, useEffect } from 'react';

const Testimonials = ({ testimonials = [] }) => {
  const [visibleCount, setVisibleCount] = useState(6);
  const [isMobile, setIsMobile] = useState(false);
  
  // Handle responsive design
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check on mount
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Default testimonials if none provided
  const defaultTestimonials = [
    {
      id: 1,
      name: "Helen W",
      handle: "@helenw",
      avatar: "🎓",
      avatarColor: "#f59e0b",
      text: "This has been invaluable as a graduate student. I work and go to school full time so being able to listen to assigned readings gives me time to actually do chores! I have actively recommended this to another student and even my professor. Lastly, I think audioread excels compared to other text-to-speech Al services in that this one is updated relatively frequently and I believe the paid version has the best quality/price ratio. amazeballs",
      rating: 5
    },
    {
      id: 2,
      name: "Aidan Torrence",
      handle: "@aidantorrence",
      avatar: "😄",
      avatarColor: "#3b82f6",
      text: "100x better than Pocket",
      rating: 5
    },
    {
      id: 3,
      name: "Arvin Garcia",
      handle: "@arvingarcia",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/ZwciQGbklIg7SH8WhgeXLQTs.jpeg",
      avatarColor: "#10b981",
      text: "I just use Audioblogs as a TLDR Audio button. I am overly excited to apply it to my digital marketing articles. I highly recommend this. This is like 100x better than Pocket, so congrats.",
      rating: 5
    },
    {
      id: 4,
      name: "Gauri Mathur",
      handle: "@gaurimathur",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/bGlxt9VLkkj42J29byTGSpv1.jpeg",
      avatarColor: "#f59e0b",
      text: "Absolutely love this product! I tend to get really distracted while reading blogs, reading while listening to its audio is a lot more effective for a goldfish like me... :D",
      rating: 5
    },
    {
      id: 5,
      name: "Brent Maxwell",
      handle: "@brentmaxwell",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/UY9UNkleJkhqfymHC0ziKzr3.jpeg",
      avatarColor: "#ef4444",
      text: "I've been using this since your launch and it's fucking fantastic - thank you so much! The quality of the voice is great - it has natural pausing that makes it just perfect for listening to blog posts. I've tried it across a bunch of blogs (firstround, SaaStr etc) and it's great! I made it read a python code. That was fun. Like a rap!",
      rating: 5
    },
    {
      id: 6,
      name: "Johanna Quinn",
      handle: "@johannaquinn",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/UxsZ1sZSJZInm0kToU1vs0x6.png",
      avatarColor: "#84cc16",
      text: "This is amazing! I can \"read\" all of the articles I say I'll get around to reading while doing my work! As an avid Audible user, the voice honestly has the same quality. And the intonation is very surprising! This is great! Wow.",
      rating: 5
    },
    {
      id: 7,
      name: "Asghar Ali Hazara",
      handle: "@asgharalihazara",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/8fvGBISkmj9u84nJL2i8s83p.jpeg",
      avatarColor: "#ec4899",
      text: "This is Absolutely Amazing and will save alot of times spent on reading. wondering if it will have an android app in future? Such a great idea... The reading voice sounds natural and calming. Well done! Have been waiting for something like this for so long. YES Amazing product I cannot state clearly enough how much I absolutely love this project and what it offers.",
      rating: 5
    },
    {
      id: 8,
      name: "Lyondhor Picciarelli",
      handle: "@lyondhorpicciarelli",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/brvBA7j9Apc5zCvmKOO63tct.jpeg",
      avatarColor: "#f97316",
      text: "Is it too much to dream of different accents? Perhaps.. New Zealand English? <3 :)",
      rating: 5
    },
    {
      id: 9,
      name: "Farzad Yousefzadeh",
      handle: "@farzadyousefzadeh",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/JX45QNSTEfY6F3HYk4iizLWE.jpeg",
      avatarColor: "#06b6d4",
      text: "Absolutely amazing! is there any plans for smartly reading code blocks too? I'm curious as to know if there is even a feasible solution to this problem.",
      rating: 5
    },
    {
      id: 10,
      name: "Mary Grace Granados",
      handle: "@marygracegranados",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/qBE3tvkDA1Eyb6zCLHRpobhb.jpeg",
      avatarColor: "#8b5cf6",
      text: "This is awesome, so helpful for people to stay engaged with the news.",
      rating: 5
    },
    {
      id: 11,
      name: "Nate Bosshard",
      handle: "@natebosshard",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/3xjHDAwEYmcWIbShRVISP6Vi.jpeg",
      avatarColor: "#3b82f6",
      text: "Been waiting for a product like this for years.",
      rating: 5
    },
    {
      id: 12,
      name: "Piotr Zgierski",
      handle: "@piotrzgierski",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/iQPyKxYgj7uG9WflqxoEcIPt.jpeg",
      avatarColor: "#10b981",
      text: "Amazing! Really good app!",
      rating: 5
    },
    {
      id: 13,
      name: "Szczepan Serwatka",
      handle: "@szczepanserwatka",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/PMTJaXqtbE81dTT4HbSZWxfX.jpeg",
      avatarColor: "#f59e0b",
      text: "Epic! Audiblogs is working perfectly in polish :) Congrats!",
      rating: 5
    },
    {
      id: 14,
      name: "Ashot Gabrielyan",
      handle: "@ashotgabrielyan",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/CKoEbxxKcLEefkQhDszcrP8K.png",
      avatarColor: "#ef4444",
      text: "Cool and very easy to use! congrats",
      rating: 5
    },
    {
      id: 15,
      name: "nika tbileli",
      handle: "@nikatbileli",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/DYzNctdFfElzzbaW1ZUfSAqg.jpeg",
      avatarColor: "#84cc16",
      text: "Great seeing new features, been using it for 4 weeks now and love it <3",
      rating: 5
    },
    {
      id: 16,
      name: "Stephanie Rahmberg Chavez",
      handle: "@stephanierahmbergchavez",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/InthCLZKSKFXoNvMgw4ppvoE.jpeg",
      avatarColor: "#ec4899",
      text: "This is really cool. I oftentimes would like to hear an article while I do other things, so this is fantastic.",
      rating: 5
    },
    {
      id: 17,
      name: "Indri Saskiaputri",
      handle: "@indrisaskiaputri",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/MPmgVDp4nhSIN4ELDxFNU6fV.jpeg",
      avatarColor: "#f97316",
      text: "Exciting product! I'm glad Eric reached out to me to try it because I've been using this to read hefty articles in the morning during work. Give it a try!",
      rating: 5
    },
    {
      id: 18,
      name: "Scott Ferguson",
      handle: "@scottferguson",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/W5z2a2LpYlg0zkt7K64qVT7T.jpeg",
      avatarColor: "#06b6d4",
      text: "This is bloody brilliant! Have been wanting something like this for a long time.",
      rating: 5
    },
    {
      id: 19,
      name: "Eric Walker",
      handle: "@ericwalker",
      avatar: "https://senja-io.s3.us-west-1.amazonaws.com/public/media/FkXAmqa13afchBZLNt2FAll3.png",
      avatarColor: "#8b5cf6",
      text: "super, I just decided to try it - I liked it! I will use",
      rating: 5
    }
  ];

  const displayTestimonials = testimonials.length > 0 ? testimonials : defaultTestimonials;
  const visibleTestimonials = displayTestimonials.slice(0, visibleCount);
  const hasMore = visibleCount < displayTestimonials.length;

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 6, displayTestimonials.length));
  };

  const renderStars = (rating) => {
    return "★".repeat(rating);
  };

  const renderAvatar = (testimonial) => {
    // If avatar is a URL, render an img tag, otherwise render the emoji
    if (testimonial.avatar && testimonial.avatar.startsWith('http')) {
      return (
        <img
          src={testimonial.avatar}
          alt={testimonial.name}
          style={{
            width: isMobile ? '40px' : '48px',
            height: isMobile ? '40px' : '48px',
            borderRadius: '50%',
            objectFit: 'cover',
            marginTop: '4px' // Match the positioning of emoji avatars
          }}
          onError={(e) => {
            // Fallback to emoji if image fails to load
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      );
    }
    
    // Render emoji avatar with centered alignment
    return (
      <div style={{
        width: isMobile ? '40px' : '48px',
        height: isMobile ? '40px' : '48px',
        borderRadius: '50%',
        backgroundColor: '#f59e0b', // Consistent orange background for emojis
        display: 'flex',
        alignItems: 'center', // Center emoji vertically
        justifyContent: 'center', // Center emoji horizontally
        fontSize: isMobile ? '20px' : '24px', // Smaller emoji on mobile
        flexShrink: 0,
        boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
        border: '2px solid rgba(245, 158, 11, 0.2)',
        padding: '4px',
        boxSizing: 'border-box'
      }}>
        {testimonial.avatar}
      </div>
    );
  };

  return (
    <div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: isMobile ? '16px' : '24px',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '16px' : '20px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        {visibleTestimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            style={{
              background: 'rgba(24, 15, 34, 0.9)',
              borderRadius: '16px',
              padding: isMobile ? '20px' : '24px',
              border: '1px solid rgba(139, 92, 246, 0.4)',
              boxShadow: '0 0 20px rgba(139, 92, 246, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
              minHeight: isMobile ? '180px' : '200px',
              display: 'flex',
              flexDirection: 'column'
            }}
            onMouseEnter={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 0 30px rgba(139, 92, 246, 0.3)';
                e.currentTarget.style.border = '1px solid rgba(139, 92, 246, 0.6)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(139, 92, 246, 0.1)';
                e.currentTarget.style.border = '1px solid rgba(139, 92, 246, 0.4)';
              }
            }}
          >
            {/* Product Hunt Badge */}
            <div style={{
              position: 'absolute',
              top: isMobile ? '12px' : '16px',
              right: isMobile ? '12px' : '16px',
              width: isMobile ? '28px' : '32px',
              height: isMobile ? '28px' : '32px',
              backgroundColor: '#ff6154',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: isMobile ? '14px' : '16px',
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(255, 97, 84, 0.3)'
            }}>
              P
            </div>

            {/* User Profile Section */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px',
              marginRight: isMobile ? '32px' : '40px' // Make room for Product Hunt badge
            }}>
              {/* Avatar with fallback */}
              <div style={{ 
                position: 'relative', 
                marginRight: isMobile ? '12px' : '16px',
                marginTop: '4px' // Add small top margin to align with text baseline
              }}>
                {renderAvatar(testimonial)}
                {/* Hidden fallback emoji for image errors */}
                {testimonial.avatar && testimonial.avatar.startsWith('http') && (
                  <div style={{
                    width: isMobile ? '40px' : '48px',
                    height: isMobile ? '40px' : '48px',
                    borderRadius: '50%',
                    backgroundColor: testimonial.avatarColor,
                    display: 'none',
                    alignItems: 'center', // Center emoji in container
                    justifyContent: 'center', // Center emoji in container
                    fontSize: isMobile ? '18px' : '20px',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    flexShrink: 0,
                    boxShadow: `0 4px 12px ${testimonial.avatarColor}40`,
                    padding: '4px',
                    boxSizing: 'border-box',
                    marginTop: '-18px' // Add small top margin to align with text baseline
                  }}>
                    😊
                  </div>
                )}
              </div>

              {/* User Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  color: '#ffffff',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '600',
                  marginBottom: '4px',
                  lineHeight: '1.2'
                }}>
                  {testimonial.name}
                </div>
                <div style={{
                  color: '#9ca3af',
                  fontSize: isMobile ? '12px' : '14px',
                  fontWeight: '500'
                }}>
                  {testimonial.handle}
                </div>
              </div>
            </div>

            {/* Testimonial Text */}
            <div style={{
              color: '#e5e7eb',
              fontSize: isMobile ? '14px' : '15px',
              lineHeight: '1.6',
              flex: 1,
              fontWeight: '400'
            }}>
              "{testimonial.text}"
            </div>

            {/* Rating */}
            <div style={{
              marginTop: '16px',
              color: '#fbbf24',
              fontSize: isMobile ? '12px' : '14px',
              fontWeight: '500'
            }}>
              {renderStars(testimonial.rating)}
            </div>
          </div>
        ))}
      </div>

      {/* Load More Button */}
      {hasMore && (
        <div style={{
          textAlign: 'center',
          marginTop: '40px',
          marginBottom: '20px'
        }}>
          <button
            onClick={handleLoadMore}
            style={{
              background: 'linear-gradient(135deg, #8535cd 0%, #e82186 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(133, 53, 205, 0.3)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              margin: '0 auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(133, 53, 205, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(133, 53, 205, 0.3)';
            }}
          >
            Load More Reviews
            {/* <span style={{ fontSize: '14px', opacity: 0.8 }}>
              ({visibleCount} of {displayTestimonials.length})
            </span> */}
          </button>
        </div>
      )}
    </div>
  );
};

export default Testimonials;
